module.exports = __webpack_public_path__ + "static/media/graph-pan.81fcf261.svg";